module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-27.f558692f.png";